import { resolveStoredPathFromDisplayPath } from '@/features/virtual-resource/fileNamePath'
import EventID from '@/model/EventClass/EventID'
import type MainProject from '@/model/MainProject'
import type DataFileMap from '@/model/Resource/DataFileMap'

const AUDIO_BASE_FOLDER_BY_CODE = new Map<EventID, string>([
  [EventID.StartBGM, '音乐'],
  [EventID.StartSE, '音效'],
  [EventID.StartVoice, '语音'],
  [EventID.StartBGS, '循环音效'],
])

/**
 * 导出前校正音频事件路径，保证事件参数保存为运行时可直接拼接的路径。
 * @param project 当前工程。
 * @param audioRoot 音频虚拟资源根。
 * @returns 是否修改过事件参数。
 */
export function normalizeProjectAudioEventPaths(
  project: MainProject | null | undefined,
  audioRoot: DataFileMap | null | undefined,
): boolean {
  if (!project || !audioRoot) return false
  let changed = false
  for (const map of project.storyTree.Maps) {
    const list = project.storyTree.loadEvent(map.Id)
    for (const event of list) {
      const baseFolder = AUDIO_BASE_FOLDER_BY_CODE.get(event.Code)
      const current = String(event.Parameter?.[0] ?? '').trim()
      if (!baseFolder || !current) continue
      const next = resolveStoredPathFromDisplayPath(audioRoot, 'audio', current, 'engine', baseFolder)
      if (!next || next === current) continue
      event.Parameter[0] = next
      changed = true
    }
  }
  return changed
}
